<div class="container">
  <mat-card>
    <form [formGroup]="reactivateClientForm" (ngSubmit)="submit()">
      <mat-card-content>
        <mat-form-field class="flex-fill" (click)="reactivationDatePicker.open()">
          <mat-label>{{ 'labels.inputs.Re Activation On Date' | translate }}</mat-label>
          <input
            matInput
            [min]="minDate"
            [max]="maxDate"
            [matDatepicker]="reactivationDatePicker"
            required
            formControlName="reactivationDate"
          />
          <mat-datepicker-toggle matSuffix [for]="reactivationDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #reactivationDatePicker></mat-datepicker>
          @if (reactivateClientForm.controls.reactivationDate.hasError('required')) {
            <mat-error>
              {{ 'labels.inputs.Reactivation Date' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          }
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!reactivateClientForm.valid">
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
